import { ChangePasswordScreen } from "@/features/auth/screens/ChangePasswordScreen";
import { changePasswordRouteSearchSchema } from "@/features/auth/search/authRouteSearch";
import { createFileRoute } from "@tanstack/react-router";

const ChangePasswordAuthPage = () => {
    const { source } = Route.useSearch();
    return <ChangePasswordScreen source={source} />;
};

export const Route = createFileRoute("/_auth/change-password")({
    component: ChangePasswordAuthPage,
    validateSearch: (search) => changePasswordRouteSearchSchema.parse(search ?? {}),
});
